import { render, staticRenderFns } from "./contactCust.vue?vue&type=template&id=19dc716f&scoped=true"
import script from "./contactCust.vue?vue&type=script&lang=js"
export * from "./contactCust.vue?vue&type=script&lang=js"
import style0 from "./contactCust.vue?vue&type=style&index=0&id=19dc716f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dc716f",
  null
  
)

export default component.exports